import DocumentAlert from './Document.Alert';
import DocumentTable from './Document.Table';
import DocumentPagination from './Document.Pagination';

interface Document {
  id: Document.Id;
  name: Document.Name;
  documentIdentityCode?: Document.DocumentIdentityCode;
  contractNumbers: Document.ContractNumber[];
  products: Document.Product[];
  date: Document.DateISO;
  isRead: boolean;
  sourceType?: Document.Source;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Document {
  export const Alert = DocumentAlert;
  export const Table = DocumentTable;
  export const Pagination = DocumentPagination;

  export type Id = string;
  export type Name = string;
  export type DocumentIdentityCode = string;
  export type ContractNumber = string;
  export type Product = string;
  export type ProductDetails = string;
  export type Categories = {
    id: number;
    name: string;
    fmsKey: string;
  };
  export type DateISO = string;
  export type Content = Blob;
  export type Source = string;

  export interface CountAPI {
    payload: {
      total: number;
    };
  }

  export interface FilterAPI {
    payload: {
      documents: {
        id: string;
        documentName: string;
        documentIdentityCode?: string;
        contractNumbers: string[];
        filedDate: string;
        fileCreationDate: string;
        fileUploadDate: string;
        readStatus: boolean;
        sourceType: Source;
        productDetails: {
          id: string;
          fmsKey: string;
        }[];
      }[];
      total: number;
      totalPages: number;
    };
  }

  export interface MetadataAPI {
    payload: {
      documentIdentityCode: string;
      id: string;
      documentName: string;
      contractNumbers: string[];
      filedDate: string;
      fileCreationDate: string;
      readStatus: boolean;
      sourceType: Source;
      productDetails: {
        id: string;
        fmsKey: string;
      }[];
    };
  }
}

export default Document;
